import { useState } from 'react'
import { Grid, Typography, IconButton, Tooltip } from '@material-ui/core'
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined'
import DownloadIcon from '@material-ui/icons/GetAppOutlined'
import DeleteDialog from '../DeleteDialog'

const ResourceList = (props) => {
  const onDelete = props.onDelete
  const canDelete = onDelete ? true : false
  const resources = props.resources
  const noDataLabel = props.noDataLabel ? props.noDataLabel : 'No hay documentos.'

  const [selectedDocto, setSelectedDocto] = useState('')
  const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false)

  const handleOpenModalDelete = (resource) => {
    setSelectedDocto(resource)
    setIsModalDeleteOpen(true)
  }

  const handleDeleteFile = async () => {
    await onDelete(selectedDocto).then(() => {
      setIsModalDeleteOpen(false)
    })
  }

  return (
    <div>
      {resources !== undefined && resources !== null && Object.keys(resources).length ? (
        Object.entries(resources).map((entry) => (
          <Grid key={`item-resource-${entry[0]}`} container spacing={1} alignItems="center">
            <Grid item xs={canDelete ? 10 : 11}>
              {entry[0]}
            </Grid>
            <Grid item xs={1}>
              <Tooltip title={`Descargar ${entry[0]}`}>
                <IconButton size="small" href={entry[1]} target="_blank" component="a">
                  <DownloadIcon />
                </IconButton>
              </Tooltip>
            </Grid>
            {canDelete && (
              <Grid item xs={1}>
                <Tooltip title={`Eliminar ${entry[0]}`}>
                  <IconButton size="small" onClick={() => handleOpenModalDelete(entry[0])}>
                    <DeleteOutlineOutlinedIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
            )}
          </Grid>
        ))
      ) : (
        <Typography color="primary" className="text-left">
          {noDataLabel}
        </Typography>
      )}
      <DeleteDialog
        open={isModalDeleteOpen}
        text={`¿Seguro que desea eliminar el archivo ${selectedDocto}?`}
        onNo={() => setIsModalDeleteOpen(false)}
        onYes={handleDeleteFile}
      />
    </div>
  )
}

export default ResourceList
